module.exports = __webpack_public_path__ + "static/8-6ccd9756c380b983671eb4578f3a3437.png";